<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <!-- 规章制度 -->
          <div class=".ny_bt">
            <p style="text-align: left; border-bottom: solid 3px rgb(12, 92, 200); margin-bottom: 30px; "><span style="font-size: 22px;">规章制度</span></p>
            <ul class="rs_lb_gzzd news_lb">
              <li style="text-align: left; vertical-align: middle" v-for="item in sliceNewsList" :key="item">
                <a :href="'/detail?type=rules&id='+item.rulesId" target="_blank" style="color: rgb(3, 61, 128);">{{ item.title }}</a>
                <span class="sj">{{ item.publish_time }}</span>
              </li>
            </ul>
          </div>
          <p>&nbsp;</p>
          <el-pagination background
                         @current-change="handleCurrentChange"
                         layout="prev, pager, next"
                         :page-size="10"
                         :total="count">
          </el-pagination>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
  /* eslint-disable */
  import Header from "@/components/header/";
  import Nav from "@/components/nav/";
  import Copy from "@/components/copy/"
  import Breadcrumb from "@/components/breadcrumb/"
  import Footer from "@/components/footer/"
  import Contact from "@/components/contact/";
  import $ from 'jquery'
  export default {
    methods: {
      handleCurrentChange(val) {
        this.currentPage = val;
        this.sliceNewsList = this.newsList.slice((this.currentPage-1) * this.pageSize, this.currentPage * this.pageSize);
        for(var i=0;i < this.sliceNewsList.length; i++) {
          this.sliceNewsList[i].publish_time = this.sliceNewsList[i].publish_time.substring(0, 10);
        }
        console.log(`当前页: ${val}`);
      }
    },
    data () {
      return {
        pageSize: 10,
        newsList: [],
        count:0,
        sliceNewsList: [],
        categoryList: [],
      };
    },
    mounted () {
      //为了在内部函数能使用外部函数的this对象，要给它赋值了一个名叫self的变量。
      var self = this;
      $.ajax({
        url:  Header.IP_URL + '/rules/simpleList',
        type: 'get',
        // data: {},
        dataType: 'json'
      }).then(function (res) {
        console.log(res);
        //把从json获取的数据赋值给数组
        self.newsList = res.data;
        self.count = res.count;
        self.sliceNewsList = self.newsList.slice(0, self.pageSize);
        for(var i=0;i < self.sliceNewsList.length; i++) {
          self.sliceNewsList[i].publish_time = self.sliceNewsList[i].publish_time.substring(0, 10);
        }
      }).fail(function () {
        console.log('失败');
      })

      // 分类
      this.categoryList = [
        {
          linkUrl: "#",
          name: "全部"
        },
        {
          linkUrl: "#",
          name: "新闻资讯"
        },
        {
          linkUrl: "#",
          name: "访问学者"
        },
        {
          linkUrl: "#",
          name: "对外合作动态"
        }

      ]
    },
    components: {
      "v-header": Header,
      "v-nav": Nav,
      "v-copy": Copy,
      "v-breadcrumb": Breadcrumb,
      "v-footer": Footer,
      "v-contact": Contact,
    }
  };
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
    .b-banner-con{
      //padding: 22px 0;
      background: url(../../assets/img/banner_bg.png) no-repeat!important;
      background-size: cover!important;
      .b-header{
        margin-bottom: 0px;
      }
      height: 134px;
      width: 1440px;
    }
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
      //padding: 22px 0;
      background: url(../../assets/img/banner_bg.png) no-repeat!important;
      background-size: cover!important;
      .b-header{
        margin-bottom: 0px;
      }
      height: 134px;
    }
  }
  //分类列表
  .b-category {
    display: flex;
    align-items: center;
    border: 1px solid #f4f4f4;
    padding: 10px;
    margin-bottom: 20px;
    .b-title {
      color: #838383;
      font-size: 14px;
      font-weight: normal;
      font-family: microsoft yahei;
      text-decoration: none;
    }
    .b-categoryList {
      ul {
        display: flex;
        align-items: center;
        .b-cate a{
          color: #333;
          font-size: 14px;
          font-family: microsoft yahei;
          padding: 2px 6px;
          margin: 0 10px;
          &:hover {
            color: #fff;
            background-color: #37617f;
          }
        }
      }
    }
  }

  .ny_bt {
    width: 100%;
    float: right;
    line-height: 70px;
    font-size: 16px;
    /*color:#949082;*/
    font-weight: 700;
    position:relative;
    padding-left:20px;
  }

  @media only screen and (min-width:1200px) {
    .rs_lb_gzzd {
      width: 100%;
      float:left;
      margin-bottom:50px;
    }
    .rs_lb_gzzd li{
      width:100%;
      float:left;
      border-bottom:dashed 1px #ddd;
      font-size:16px;
      line-height:60px;
    }
    .rs_lb_gzzd a{
      width:100%;
      display:block;
      height:60px;
      text-overflow:ellipsis; overflow:hidden;  white-space: nowrap;
      position:relative;
      /*padding-left:45px;*/
      padding-left:20px;
      font-size: 16px;
      color: rgb(167, 32, 56);
    }
  }
  @media only screen and (max-width:1200px) {
    .rs_lb_gzzd.news_lb li{
      position:relative;
      padding-right:80px;
    }
    .rs_lb_gzzd.news_lb .sj{
      position:absolute;
      width:70px;
      right:0px;
      top:0px;
      color: rgb(167, 32, 56);
    }
    .zp_nr{
      width:100%;
      float:left;
      background-color:#ffffff;
      padding:15px;
    }
  }
  .rs_lb_gzzd li:nth-of-type(even){
    background-color: white;
  }
  .rs_lb_gzzd li:hover{
    background-color:#186ed0;
    border-bottom:solid 1px #186ed0;
  }
  .rs_lb_gzzd li:hover a,.rs_lb_gzzd li:hover .sj{
    color:#ffffff;
  }
  .rs_lb_gzzd li:hover a:after{
    background-color:#ffffff;
  }
  @media only screen and (min-width:1200px) {
    .rs_lb_gzzd.news_lb li{
      position:relative;
      padding-right:120px;
    }
    .rs_lb_gzzd.news_lb .sj{
      position:absolute;
      width:180px;
      right:0px;
      top:0px;
      color: rgb(3, 61, 128);;
    }
    .zp_nr{
      width:100%;
      float:left;
      background-color:#ffffff;
      padding:25px 30px;
      font-size:16px;
      line-height: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/rules/index.vue